module.exports = __webpack_public_path__ + "img/IRQ.fae5f24b.svg";